import { render, staticRenderFns } from "./feePlatform.vue?vue&type=template&id=f0896ac8&scoped=true"
import script from "./feePlatform.vue?vue&type=script&lang=js"
export * from "./feePlatform.vue?vue&type=script&lang=js"
import style0 from "./feePlatform.vue?vue&type=style&index=0&id=f0896ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0896ac8",
  null
  
)

export default component.exports